import i18n from "i18next";
import React from "react";
import {Link} from "@inertiajs/inertia-react";
import '@/../sass/authenticated/adminaccountoverview.scss';

export function AddSubOrganizationCard() {
    return (
        <div data-testid="add_sub_organization_card-div" className="add-organization-card">
            <span className="add-organization-text">{i18n.t('manage.add-organization-text')}</span>
            <span>
                <Link data-testid="add_sub_organization_card-button"
                    as="button"
                    method="GET"
                    href={route('create.sub-organization.show')}
                    className="add-organization-button"
                >
                <span><i className="fa-plus fas add-organization-text add-icon"></i>{i18n.t('manage.add-organization-button-title')}</span>
                </Link>
            </span>
        </div>
    )
}
